import React from 'react';
import { LineChart as ChartLineUp, Sliders, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface StrengthCardProps {
  icon: React.ReactNode;
  title: string;
  text: string;
  delay: string;
}

const StrengthCard: React.FC<StrengthCardProps> = ({ icon, title, text, delay }) => {
  return (
    <div 
      className="bg-[#0F1C33] rounded-xl p-8 transition-all duration-300 animate-on-scroll hover:shadow-[0_0_30px_rgba(18,198,232,0.15)]"
      style={{ transitionDelay: delay }}
    >
      <div className="text-[40px] mb-6 text-[#12C6E8]">
        {icon}
      </div>
      <h3 className="font-heading text-xl font-bold mb-3">{title}</h3>
      <p className="text-text-secondary">{text}</p>
    </div>
  );
};

const Strengths: React.FC = () => {
  const { t } = useTranslation();

  const strengths = [
    {
      icon: <ChartLineUp />,
      title: t('strengths.card1.title'),
      text: t('strengths.card1.text')
    },
    {
      icon: <Sliders />,
      title: t('strengths.card2.title'),
      text: t('strengths.card2.text')
    },
    {
      icon: <ShieldCheck />,
      title: t('strengths.card3.title'),
      text: t('strengths.card3.text')
    }
  ];

  return (
    <section id="strategy" className="section-spacing bg-bg-secondary">
      <div className="container-custom">
        <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center animate-on-scroll">
          {t('strengths.heading')}
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {strengths.map((strength, index) => (
            <StrengthCard
              key={index}
              icon={strength.icon}
              title={strength.title}
              text={strength.text}
              delay={`${0.1 * (index + 1)}s`}
            />
          ))}
        </div>

        <p className="text-center text-text-secondary mt-12 text-lg font-medium animate-on-scroll">
          {t('strengths.disclaimer')}
        </p>
      </div>
    </section>
  );
};

export default Strengths;